import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Card} from '../../../card-container/card/card';
import {Student360Service} from '../../../../student360.service';
import {Portal} from '../../../../../shared-components/portal.model';
import {UserService} from '../../../../../shared-components/user/user.service';
import * as _ from 'lodash';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {Subscription} from 'rxjs';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-district-defined-links-card',
    templateUrl: './district-defined-links-card.component.html',
    styleUrls: ['./district-defined-links-card.component.css']
})

export class DistrictDefinedLinksCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    linkTiles: Portal[] = [];
    subscriptions: Subscription[] = [];
    card: Card;
    userIsStaff = false;

    constructor(private student360Service: Student360Service, private userService: UserService) {
    }

    ngOnInit() {
        this.card = this.data;
        this.student360Service.observableParentAssignedPortalsStream$.subscribe(response => {
            this.linkTiles = response.filter(p => p.IsMyLinksTile == true);
        });
        // A staff person should not see this card
        this.userIsStaff = this.userService.userType == 1;
        // Sometimes the view will be re-rendered without the portals changing
        if (this.linkTiles.length <= 0) {
            if (this.student360Service.parentAssignedPortals) {
                this.linkTiles = _.cloneDeep(this.student360Service.parentAssignedPortals.filter(p => p.IsMyLinksTile == true));
            }
        }
    }

    ngOnDestroy(): void {
    }

    hasImage(link: Portal) {
        if (link.TileImageFile) {
            return true;
        } else {
            return false;
        }
    }

    linkTileClick(link: Portal) {
        if (link.OpenInNewWindow) {
            window.open(link.PortalDescription, '_blank');
        } else {
            window.open(link.PortalDescription);
        }
    }

}
